import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Payment } from '../../types/dashboard';
import { formatDate, formatCurrency } from '../../utils/formatters.ts';

interface PaymentHistoryProps {
  data: Payment[];
}

const PaymentHistory: React.FC<PaymentHistoryProps> = ({ data }) => {
  const navigate = useNavigate();

  const handlePaymentClick = (paymentId: string) => {
    navigate(`/payments/${paymentId}`);
  };

  return (
    <div className="chart-container">
      <h3>Recent Payments</h3>
      <div className="payment-history-wrapper">
        {/* Desktop View */}
        <table className="payment-table desktop-only">
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Mode</th>
            </tr>
          </thead>
          <tbody>
            {data.map((payment) => (
              <tr 
                key={payment.id}
                onClick={() => handlePaymentClick(payment.id)}
                className="payment-row"
                style={{ cursor: 'pointer' }}
              >
                <td>{formatDate(payment.payment_date)}</td>
                <td>{formatCurrency(payment.total_amount)}</td>
                <td>{payment.payment_mode}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Mobile View */}
        <div className="payment-cards mobile-only">
          {data.map((payment) => (
            <div 
              key={payment.id} 
              className="payment-card"
              onClick={() => handlePaymentClick(payment.id)}
              style={{ cursor: 'pointer' }}
            >
              <div className="payment-card-row">
                <span className="payment-date">{formatDate(payment.payment_date)}</span>
                <span className="payment-amount">{formatCurrency(payment.total_amount)}</span>
              </div>
              <div className="payment-mode">{payment.payment_mode}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PaymentHistory;
